"use client";

import { useSidebar } from "@workspace/frontend-ui";
import type AppLink from "@workspace/nextjs_utils/src/components/AppLink";
import useLocalizedPath from "@workspace/nextjs_utils/src/siteInfo/useLocalizedPath";
import { useSearchParams } from "next/navigation";
import { type ComponentProps, useEffect } from "react";

type LocalizedHref = ComponentProps<typeof AppLink>["href"];

// `?menu=open` renders the page with the mobile menu open: the old /menu and
// /menu/more pages redirect here. bot-render-cf-worker's cacheKey keeps the
// param, so a crawler's open-menu snapshot never replaces the page's own.
const MENU_PARAM = "menu";

// The home page with the menu open, in the page's language: the menu link
// points here so crawlers can follow it, and the home page alone keeps the
// param in its canonical. No trailing slash ("/pt", not "/pt/"), which would
// cost crawlers a redirect.
export const useOpenMenuHref = (): LocalizedHref => {
  const home = useLocalizedPath("/");
  return `${home}?${MENU_PARAM}=open` as LocalizedHref;
};

const OpenMenuParam = () => {
  const isMenuOpen = useSearchParams().get(MENU_PARAM) === "open";
  const { setOpenMobile } = useSidebar();

  useEffect(() => {
    if (isMenuOpen) {
      setOpenMobile(true);
    }
  }, [isMenuOpen, setOpenMobile]);

  return null;
};

export default OpenMenuParam;
